import { useEffect, useRef, useState } from 'react';

import { STATUS_CODES } from '@/pages/fert-work/utils/statusHelpers';

import { useGetSessionStatusQuery } from '../services/fertWork';

export const useFertWorkSessionPolling = (sessionId: string | null) => {
  const [isPolling, setIsPolling] = useState(true);
  const prevSessionIdRef = useRef(sessionId);

  useEffect(() => {
    if (sessionId && sessionId !== prevSessionIdRef.current) {
      setIsPolling(true);
    }
    prevSessionIdRef.current = sessionId;
  }, [sessionId]);

  const {
    data: status,
    isLoading,
    error,
  } = useGetSessionStatusQuery(sessionId || '', {
    pollingInterval: isPolling && sessionId ? 1000 : 0,
    skip: !sessionId || !isPolling,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (status) {
      if (
        status.status === STATUS_CODES.IN_PROGRESS ||
        status.status === STATUS_CODES.COMPLETE ||
        status.status === STATUS_CODES.ERROR ||
        status.status === STATUS_CODES.ISSUES
      ) {
        setIsPolling(false);
      }
    }
  }, [status]);

  const resetPolling = () => {
    setIsPolling(true);
  };

  return {
    status,
    isPolling,
    isLoading,
    error,
    resetPolling,
  };
};
